import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { Show } from '@refinedev/antd';
import { Typography } from 'antd';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const GraduateDisciplineShow = () => {
  const { queryResult } = useShow<IGraduateDiscipline>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading} title="Visualizar disciplina">
      <Title level={5}>ID</Title>
      <Text>{record?.id}</Text>
      <Title level={5}>Nome</Title>
      <Text>{record?.name}</Text>
      <Title level={5}>Duração (horas)</Title>
      <Text>{record?.duration_in_minutes}</Text>
    </Show>
  );
};
